var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqsIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10637_17228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2994 27.2574V0.400146H0.578125V28.6371C0.578125 30.2727 1.90579 31.6003 3.54138 31.6003H27.3034",
    stroke: "#148D9B",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 31.6003C5.15866 31.6003 5.7785 30.2887 5.7785 28.6691V27.2534H31.4281V27.4734C31.4281 29.7528 29.5806 31.6003 27.3011 31.6003",
    stroke: "#148D9B",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16016 16H23.5161",
    stroke: "#148D9B",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16016 8H23.5161",
    stroke: "#148D9B",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16016 12H23.5161",
    stroke: "#148D9B",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10637_17228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6521,
    height: 32,
    fill: "white",
    transform: "translate(0.175781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqsIcon6);
export default __webpack_public_path__ + "static/media/faqs-icon-6.123e3d16d8087cfa8c12ff98139ee24b.svg";
export { ForwardRef as ReactComponent };